import React from "react";
import { DocumentoSetorialDetailsPage } from "./documentoSetorialDetails.page";
import { DocumentoSetorialDetailsProvider } from "./context/documento-setorial-details-context";

export function DocumentoSetorialDetailsFactory() {
    return (
        <DocumentoSetorialDetailsProvider>
            <DocumentoSetorialDetailsPage />
        </DocumentoSetorialDetailsProvider>
    );
}
